import React from 'react';
import Background from "../assets/splash-bg.jpg";
import './TexasIslamicConference.css'; // import css
import Footer from './Footer.tsx';

const TamuIC = () => {
  return (
    <div>
      <div className="tamuIC-container">
        <div 
          className="tamuIC-hero-section" 
          style={{ backgroundImage: `url(${Background})` }}
        >
          <div className="tamuIC-overlay"></div>
          <div className="tamuIC-content">
            <div className="tamuIC-title-section">
              <h1 className="tamuIC-script-title">Texas Islamic Conference</h1>
              <h2 className="tamuIC-main-title">VOICES OF VIRTUE</h2>
            </div>
          </div>
        </div>
        
        <div className="tamuIC-info-section">
          <div className="tamuIC-info-content">
            <p className='tamuIC-paragraph'>
              Starting from 2025, <strong>Voices of Virtue</strong> is an Islamic conference 
              that is held every fall in Bryan-College Station, Texas, home of <strong>Texas A&M 
                University Muslim Students' Association (TAMU MSA)</strong>. After the success of 
                <strong> Texas Deen Intensive (DI)</strong> in Austin, Texas, TAMU MSA wanted to hold 
                a similar conference in College Station. With the support of the DI executives, the 
                initiative was born. Every year, we bring your favorite speakers, local and abroad, 
                and focus on a theme to inspire and educate the ummah. Although the content and delivery 
                targets university students and young professionals, anyone above the age of 18 is welcome 
                to register and join us!
            </p>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default TamuIC;